import React from 'react'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import styles from './DepartmentDetails.module.scss'
import { DepartmentDetailsTable } from './DepartmentDetailsTable/DepartmentDetailsTable'
import { useDepartmentDetails } from './hooks'
import { NavLink } from 'redux-first-router-link'
import { Icon } from 'components/shared/Icon/Icon'
import { t } from 'ttag'
import { ChevronRightIcon } from 'components/shared/Icon/model'
import { Button } from 'components/shared/Button/Button'
import { CornerLeftUpIcon } from 'components/shared/Icon/Icon'

export const DepartmentDetails = ({ id }) => {
  const { state, handlers } = useDepartmentDetails({ id })

  const { search, department } = state
  const { setSearch, handleRedirectToProjects } = handlers

  return (
    <Pane tagName="article">
      <Pane.Header
        title={
          <span className={styles.title}>
            <span className={styles.departmentsLink}>
              <NavLink className={styles.link} to={'/departments'}>
                {t`Departments`}
              </NavLink>
            </span>
            <Icon className={styles.icon} icon={ChevronRightIcon} />
            <span>{department.name}</span>
          </span>
        }
        className={styles.header}
      >
        <SearchWidget query={search} onChange={setSearch} />
        <Button
          color="primary"
          icon={CornerLeftUpIcon}
          label={t`View jobs`}
          size="small"
          variant="filled"
          onClick={() =>
            handleRedirectToProjects(undefined, undefined, { department: id })
          }
        />
      </Pane.Header>
      <DepartmentDetailsTable search={search} id={id} />
    </Pane>
  )
}
